// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__AcWGP","social_list":"Footer_social_list__dKbUn","copy_right":"Footer_copy_right__ZgZsx"};